import React, { Component, Fragment } from 'react';
import classes from './Modal.css';
import Backdrop from '../../UI/Backdrop/Backdrop.jsx';





class Modal extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.show !== this.props.show || nextProps.children !== this.props.children;
  }

  render() {
    const modalClasses = [classes.Modal];

    if (this.props.show) {
      modalClasses.push(classes.show);
    }

    if (this.props.error) {
      modalClasses.push(classes.Error)
    }

    return (
      <Fragment>
        <Backdrop show={this.props.show} clicked={this.props.clicked} />
        <div className={modalClasses.join(' ')}>
          {this.props.children}
        </div>
      </Fragment>
    )
  }

}

export default Modal;


// WEBPACK FOOTER //
// ./src/components/UI/Modal/Modal.jsx